import React, { ReactNode } from 'react';
import { CollapseWrapper, ContentWrapper, IconWrapper, ToggleButton } from './CollapseComponentStyle.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface CollapseProps {
    headerText: string;
    children: ReactNode;
    isOpen: boolean;
    title?: string;
    setisOpen: (isOpen: boolean) => void;
    style?: React.CSSProperties;
}

const CollapseComponent: React.FC<CollapseProps> = ({ headerText, children, isOpen, setisOpen, style, title }) => {
    const toggleCollapse = () => {
        setisOpen(!isOpen);
    };
    return (
        <CollapseWrapper style={style} title={title ?? ''}>
            <ToggleButton onClick={toggleCollapse}>
                <IconWrapper>
                    <FontAwesomeIcon icon={isOpen ? 'chevron-down' : 'chevron-right'} />
                </IconWrapper>
                <h4>{headerText}</h4>
            </ToggleButton>
            <ContentWrapper isOpen={isOpen}>{children}</ContentWrapper>
        </CollapseWrapper>
    );
};

export default CollapseComponent;
